import { Chain } from "wagmi";
import { InjectedConnector } from "wagmi/connectors/injected";
import { Wallet } from "@rainbow-me/rainbowkit";

export interface ExodusOptions {
  chains: Array<Chain>;
  shimDisconnect?: boolean;
}

export const exodusWallet = ({ chains, shimDisconnect }: ExodusOptions): Wallet => ({
  id: "exodus",
  name: "Exodus",
  iconUrl: async () => (await import("./exodusWallet.svg")).default,
  iconBackground: "#fffffff",
  installed: typeof window !== "undefined" && window.ethereum?.isExodus === true,
  downloadUrls: {
    browserExtension:
      "https://chrome.google.com/webstore/detail/exodus/aholpfdialjgjfhomihkjbmgjidlcdno",
  },
  createConnector: () => {
    return {
      connector: new InjectedConnector({
        chains,
        options: { shimDisconnect },
      }),
    };
  },
});
